$(function () {
  var timeout = null
  $('[data-behaviour~=subheader]').mouseenter(function (e) {
    var $subheader = $('#subheader')
      , $this = $(e.target).closest('a')
      , target = $this.data('target')
    if (!target) {
      $subheader.slideUp()
      return
    }
    var $target = $subheader.find('.' + target)
    if ($subheader.is(':visible')) {
      $subheader.find('>div').hide()
      $target.show()
    } else {
      $subheader.find('>div').hide()
      $target.show()
      $subheader.slideDown()
    }
    if (timeout) clearTimeout(timeout)
  })
  $('.header, .subheader').mouseenter(function (e) {
    if (timeout) clearTimeout(timeout)
  })
  $('.header, .subheader').mouseleave(function (e) {
    var $subheader = $('#subheader')
    timeout = setTimeout(function () {
      $subheader.slideUp()
    }, 500)
  })
})
